export default [
    {
        path: '/company/setup',
        name: 'CompanySetup',
        component: () => import('@/views/company/setting/SetupWizard.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.setup',
        }
    },
    {
        path: '/company/staff',
        name: 'CompanyStaff',
        component: () => import('@/views/company/staff/index.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.staff',
            permissions: ['system.managers.view.all']
        }
    },
    {
        path: '/company/staff/new',
        name: 'NewCompanyUser',
        component: () => import('@/views/company/staff/CreateEmployeeWizard.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.staff_new',
            permissions: ['system.managers.view']
        }
    },
    {
        path: '/company/setting/main',
        name: 'MainSetting',
        component: () => import('@/views/company/setting/index.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.settings_main',
        },
    },
    {
        path: '/company/setting/notification',
        name: 'CompanySettingNotification',
        component: () => import('@/views/company/setting/notification.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.settings_notification',
            permissions: ['system.setting.email']
        }
    },
    {
        path: '/company/billing',
        name: 'CompanyBilling',
        component: () => import('@/views/company/billing/index.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.billing',
            permissions: ['system.setting.company']
        }
    },
    {
        path: '/company/partners',
        name: 'CompanyPartners',
        component: () => import('@/views/company/Partners/index.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.partners',
            permissions: ['samo.partner.setting']
        }
    },
    {
        path: '/company/partners/history',
        name: 'CompanyPartnersHistory',
        component: () => import('@/views/company/Partners/history.vue'),
        meta: {
            access: 'auth',
            title: 'routes.company.partners_history',
            permissions: ['samo.partner.setting']
        }
    },
    {
        path: '/hotel/price-request',
        name: 'emailSendHotel',
        component: () => import('@/views/samo/HotelPriceRequests.vue'),
        meta: {
            access: 'auth',
            title: 'samo.hotelPriceRequests.pageTitle',
      //      permissions: ['samo.hotel.pricerequest']
        }
    },
];